import { useState } from "react";

// Import inhouse icons
import { X, Image } from "@/components/icons_new";

// Import Hooks and utils
import { 
    getImageName,
    getExtension,
    getFileSize,
    getDimensions,
    getUploadDate,
} from "@/utils/fallbacks/imageMetaFallbacks";

// Import React skeleton
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

export default function ImagePreviewPanel({ image, onClose, isLoading = false }) {
    const [imageError, setImageError] = useState(false);

    if (!image || typeof image !== "object") return null;

    return (
        <div className="flex flex-col w-[320px] px-6 py-6 bg-[#fcfcfc] transition-all duration-300">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-sm font-semibold text-[#000] tracking-wide">Preview</h2>
            <X
              className="w-4 h-4 cursor-pointer text-[#666] hover:text-[#111]"
              onClick={onClose}
            />
          </div>

          {/* Image Frame */}
          <div className="bg-[#f9f9f9] border border-[#e5e5e5] rounded-[12px] overflow-hidden mb-5 h-[200px] flex items-center justify-center">
            {isLoading ? (
              <Skeleton 
                height={200} 
                width={"100%"}
                aria-hidden="true"
              />
            ) : !image?.url || imageError ? (
              <div className="flex items-center justify-center w-full h-[200px] bg-[#f0f0f0] rounded-md">
                <Image className="w-10 h-10 text-[#ccc]" />
              </div>
            ) : (
              <img
                src={image.url}
                alt={image.alt || "Image preview"}
                onError={() => setImageError(true)}
                className="w-full h-full object-contain"
              />
            )}
          </div>

          {/* File Info */}
          <div className="text-[14px] text-[#333] space-y-2">
            {["Name", "Extension", "File size", "Dimensions", "Uploaded"].map((label, i) => {
              const value = [
                getImageName(image),
                getExtension(image),
                getFileSize(image),
                getDimensions(image),
                getUploadDate(image),
              ][i];
            
              return (
                <div key={label}>
                  <span className="text-[#999] block text-xs mb-1">{label}</span>
                  <span className="text-[#222] font-medium break-all">
                    {isLoading ? <Skeleton width={180} /> : value}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
    );
};

